export default [
    {
        path: '/menus',
        name: 'menus',
        component: () => import('../views/Menu.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'default',
            breadcrumb: 'menus',
            description: 'Gestion des menus'
        }
    },
    {
        path: '/niveaux',
        name: 'menus-parts',
        component: () => import('../views/MenuPart.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'default',
            breadcrumb: 'niveaux de menu',
            description: 'Gestion des niveaux de menu'
        }
    }
]
